import { StrictMode, render } from "@wordpress/element";
import ProcessesList from "./ProcessesList";

window.addEventListener("DOMContentLoaded", (event) => {
    const wrapper = document.getElementById(`processes-list`);
    if (!wrapper) {
        console.error("ProcessesList: Element not found");
        return;
    }
    render(<ProcessesList />, wrapper);
});
